import React from 'react';

import RangeSelect from '../RangeSelect';
import BoxSizeSelector from './BoxSizeSelector';
import Shuffle from './Shuffle';

import { ControlsContainer } from '../../styles';

const SelectorControls = ({
  isMobile,
  handleRangeSwitch,
  isMini,
  setIsMini,
  limit,
  sizes,
  handleLimitChange,
  randomise,
  setExpanded,
  expanded,
}) => {
  return (
    <ControlsContainer className="row px-2 px-md-0">
      <RangeSelect
        handleRangeSwitch={handleRangeSwitch}
        isMini={isMini}
        setIsMini={setIsMini}
      />
      {!isMobile && (
        <BoxSizeSelector
          limit={limit}
          sizes={sizes}
          handleLimitChange={handleLimitChange}
          nolabel={false}
        />
      )}
      <Shuffle
        randomise={randomise}
        setExpanded={setExpanded}
        expanded={expanded}
      />
    </ControlsContainer>
  );
};

export default SelectorControls;
